<t-llevo-dialog-header
  dialogTitle="Editar usuario"
  mat-dialog-title
></t-llevo-dialog-header>

<mat-dialog-content commonui-loader [appLoader]="loading() ?? false">
  <form [formGroup]="frm" class="formGroup">
    <mat-form-field>
      <mat-label>Nombre</mat-label>
      <input #firstInput matInput formControlName="firstname" />
      @if(firstname.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Apellidos</mat-label>
      <input matInput formControlName="lastname" />
      @if(lastname.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Número telefónico</mat-label>
      @if(phone.errors){
      <mat-hint>Formato requerido: 8 números (55125432)</mat-hint>
      }
      <input matInput formControlName="phone" maxlength="8" />
      @if(phone.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      }@else if(phone.hasError('pattern')) {
      <mat-error>Formato requerido: 8 números</mat-error>
      }
    </mat-form-field>

    <mat-form-field>
      <mat-label>Email</mat-label>
      <input matInput formControlName="email" />
      @if(email.hasError('required')){
      <mat-error>Campo requerido</mat-error>
      } @else if(email.hasError('pattern')){
      <mat-error>Formato de correo incorrecto</mat-error>
      }
    </mat-form-field>
  </form>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-flat-button mat-dialog-close>Cancelar</button>
  <button
    mat-flat-button
    (click)="onSubmit()"
    [disabled]="frm.invalid || frm.pristine || (loading() ?? false)"
    color="accent"
  >
    Guardar cambios
  </button>
</mat-dialog-actions>
